export default __webpack_public_path__ + "a8362f37d8369926ea07cb730fd135c0.png";